// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/exports-last */
/** @jsx jsx */
import React from 'react'
import PropTypes from 'prop-types'
import VSensor from 'react-visibility-sensor'
import { jsx } from 'theme-ui'

class VisibilitySensor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: true,
    }
  }

  render() {
    const { active } = this.state
    const { once, children, ...theRest } = this.props
    return (
      <VSensor
        active={active}
        onChange={isVisible => once && isVisible && this.setState({ active: false })}
        {...theRest}
      >
        {({ isVisible }) => children({ isVisible })}
      </VSensor>
    )
  }
}

// eslint-disable-next-line react/display-name
export const withVSensor = Component => props =>
  (
    <VisibilitySensor once>
      {({ isVisible }) => <Component {...props} isVisible={isVisible} />}
    </VisibilitySensor>
  )

VisibilitySensor.propTypes = {
  once: PropTypes.bool,
  children: PropTypes.func.isRequired,
}

VisibilitySensor.defaultProps = {
  once: false,
}

export default VisibilitySensor
